module.exports = __webpack_public_path__ + "static/media/apple.55820033.svg";